import { render, staticRenderFns } from "./PickupRegionsSelect.vue?vue&type=template&id=045511d7&"
import script from "./PickupRegionsSelect.vue?vue&type=script&lang=js&"
export * from "./PickupRegionsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports